var React = require('react');

function Search24 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"8","stroke":"#838383","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16.5 16.9579L21.5 21.958","stroke":"#838383","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search24;

Search24.default = Search24;
